<template>
  <b-card v-if="week">
    <div class="d-flex justify-content-between align-items-start flex-wrap mb-2">
      <div>
        <h3 class="mb-0">{{ week.name }}</h3>
        <small class="text-muted">{{ formatPeriod(week.period) }}</small>
        <div v-if="week.topics && week.topics.length" class="mt-50">
          <b-badge
            v-for="t in week.topics"
            :key="t.id"
            variant="light-primary"
            class="mr-50"
          >
            {{ t.name }}
          </b-badge>
        </div>
      </div>
      <b-button variant="outline-secondary" :to="{ name: 'finance', query: { tab: 'weeks' } }">
        <feather-icon icon="ArrowLeftIcon" class="mr-50" />
        К списку недель
      </b-button>
    </div>

    <b-row>
      <b-col cols="12" md="6" lg="3" class="mb-1">
        <div class="d-flex align-items-center">
          <b-avatar size="48" variant="light-success">
            <feather-icon icon="TrendingUpIcon" size="22" />
          </b-avatar>
          <div class="ml-1">
            <small class="text-muted d-block">Выручка</small>
            <h3 class="mb-0">{{ formatRub(week.revenue) }}</h3>
          </div>
        </div>
      </b-col>

      <b-col cols="12" md="6" lg="3" class="mb-1">
        <div class="d-flex align-items-center">
          <b-avatar size="48" :variant="`light-${profitVariant(week.profit)}`">
            <feather-icon icon="DollarSignIcon" size="22" />
          </b-avatar>
          <div class="ml-1">
            <small class="text-muted d-block">Прибыль</small>
            <h3 class="mb-0" :class="`text-${profitVariant(week.profit)}`">
              {{ formatRub(week.profit) }}
            </h3>
            <small class="text-muted">Маржа: {{ formatPercent(week.margin) }}</small>
          </div>
        </div>
      </b-col>

      <b-col cols="12" md="6" lg="3" class="mb-1">
        <div class="d-flex align-items-center">
          <b-avatar size="48" variant="light-danger">
            <feather-icon icon="ArrowDownCircleIcon" size="22" />
          </b-avatar>
          <div class="ml-1">
            <small class="text-muted d-block">Расходы</small>
            <h3 class="mb-0">{{ formatRub(week.expenses && week.expenses.total) }}</h3>
            <small class="text-muted">
              Х: {{ formatRub(week.expenses && week.expenses.hosts) }}
              · А: {{ formatRub(week.expenses && week.expenses.authors) }}
            </small>
          </div>
        </div>
      </b-col>

      <b-col cols="12" md="6" lg="3" class="mb-1">
        <div class="d-flex align-items-center">
          <b-avatar size="48" variant="light-warning">
            <feather-icon icon="UsersIcon" size="22" />
          </b-avatar>
          <div class="ml-1">
            <small class="text-muted d-block">Игр</small>
            <h3 class="mb-0">{{ gamesCount }}</h3>
            <small class="text-muted">{{ playersCount }} игроков</small>
          </div>
        </div>
      </b-col>
    </b-row>

    <hr v-if="hasPrivate">

    <div v-if="hasPrivate">
      <small class="text-info text-uppercase font-weight-bolder d-block mb-1">
        <feather-icon icon="LockIcon" class="mr-25" />
        Частные игры
      </small>
      <b-row>
        <b-col cols="6" md="4" class="mb-1 text-center">
          <small class="text-muted d-block">Игр</small>
          <h5 class="mb-0 text-info">{{ week.private.games_count }}</h5>
          <small class="text-muted">из {{ gamesCount }}</small>
        </b-col>
        <b-col cols="6" md="4" class="mb-1 text-center">
          <small class="text-muted d-block">Игроков</small>
          <h5 class="mb-0 text-info">{{ week.private.players_count }}</h5>
          <small class="text-muted">из {{ playersCount }}</small>
        </b-col>
        <b-col cols="6" md="4" class="mb-1 text-center">
          <small class="text-muted d-block">Выручка</small>
          <h5 class="mb-0 text-info">{{ formatRub(week.private.revenue) }}</h5>
          <small class="text-muted">из {{ formatRub(week.revenue) }}</small>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import { BCard, BRow, BCol, BButton, BBadge, BAvatar } from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import { formatRub, formatPercent, formatPeriod, profitVariant } from '@/views/finance/utils'

export default {
  components: { BCard, BRow, BCol, BButton, BBadge, BAvatar },
  props: {
    week: { type: Object, default: null },
  },
  setup(props) {
    const games = computed(() => (props.week && props.week.games) || [])

    const gamesCount = computed(() => games.value.length)

    const playersCount = computed(() => games.value.reduce((acc, g) => acc + (g.players_count || 0), 0))

    const hasPrivate = computed(() => {
      const p = props.week && props.week.private
      return !!(p && (p.games_count || p.players_count || p.revenue))
    })

    return {
      gamesCount,
      playersCount,
      hasPrivate,
      formatRub,
      formatPercent,
      formatPeriod,
      profitVariant,
    }
  },
}
</script>
